var _a, _b, _c, _d, _e;
import { alcoholFrequency, caffeineFrequency, cannabisFrequency, nicotineFrequency, usedSubstance, } from './ehrNoteEnums';
export var substanceConfig = (_a = {},
    _a[usedSubstance.alcohol] = {
        label: 'Alcohol',
        isCommon: true,
        frequencies: (_b = {},
            _b[alcoholFrequency.none] = 'None',
            _b[alcoholFrequency.lessThanOnePerWeek] = 'Less than 1 drink/week',
            _b[alcoholFrequency.oneTo5DrinksPerWeek] = '1-5 drinks weekly',
            _b[alcoholFrequency.sixToTenDrinksPerWeek] = '6-10 drinks weekly',
            _b[alcoholFrequency.elevenToFourteenDrinksPerWeek] = '11-14 drinks weekly',
            _b[alcoholFrequency.fifteenPlusDrinksPerWeek] = '15+ drinks weekly',
            _b[alcoholFrequency.bingeDrinking] = 'Binge Drinking',
            _b[alcoholFrequency.blackoutHistory] = 'Blackout History',
            _b),
    },
    _a[usedSubstance.nicotine] = {
        label: 'Nicotine/Tobacco',
        isCommon: true,
        frequencies: (_c = {},
            _c[nicotineFrequency.none] = 'None',
            _c[nicotineFrequency.twoOrMoreTimesADay] = '2+ times a day',
            _c[nicotineFrequency.onceADay] = 'Once a day',
            _c[nicotineFrequency.threeOrMoreTimesAWeek] = '3+ times/week',
            _c[nicotineFrequency.oneOrTwoTimesAWeek] = '1-2 times/week',
            _c[nicotineFrequency.lessThanWeekly] = 'Less than weekly',
            _c),
    },
    _a[usedSubstance.caffeine] = {
        label: 'Caffeine',
        isCommon: true,
        frequencies: (_d = {},
            _d[caffeineFrequency.none] = 'None',
            _d[caffeineFrequency.oneToTwoCupsDaily] = '1-2 cups daily equivalent',
            _d[caffeineFrequency.threeToFourCupsDaily] = '3-4 cups daily equivalent',
            _d[caffeineFrequency.fiveOrMoreCupsDaily] = '5+ cups daily equivalent',
            _d),
    },
    _a[usedSubstance.cannabis] = {
        label: 'Cannabis',
        isCommon: true,
        frequencies: (_e = {},
            _e[cannabisFrequency.none] = 'None',
            _e[cannabisFrequency.twoOrMoreTimesADay] = '2+ times a day',
            _e[cannabisFrequency.onceADay] = 'Once a day',
            _e[cannabisFrequency.threeOrMoreTimesAWeek] = '3+ times/week',
            _e[cannabisFrequency.oneToTwoTimesAWeek] = '1-2 times/week',
            _e[cannabisFrequency.lessThanOnceAWeek] = 'Less than weekly',
            _e),
    },
    _a[usedSubstance.inhalants] = {
        label: 'Inhalants',
        isCommon: false,
    },
    _a[usedSubstance.opioids] = {
        label: 'Opioids',
        isCommon: false,
    },
    _a[usedSubstance.sedativesBenzodiazepines] = {
        label: 'Sedatives / Benzodiazepines',
        isCommon: false,
    },
    _a[usedSubstance.ecstasy] = {
        label: 'Ecstasy',
        isCommon: false,
    },
    _a[usedSubstance.amphetaminesMethamphetamine] = {
        label: 'Amphetamines / Methamphetamine',
        isCommon: false,
    },
    _a[usedSubstance.cocaine] = {
        label: 'Cocaine',
        isCommon: false,
    },
    _a[usedSubstance.otherStimulants] = {
        label: 'Other Stimulants (incl. Adderall)',
        isCommon: false,
    },
    _a[usedSubstance.hallucinogens] = {
        label: 'Hallucinogens',
        isCommon: false,
    },
    _a[usedSubstance.overTheCounterMedications] = {
        label: 'Over the Counter Medications',
        isCommon: false,
    },
    _a[usedSubstance.other] = {
        label: 'Other',
        isCommon: false,
        isFreeForm: true,
    },
    _a);
